import { ReactElement } from "react";
import styles from "./stickyGradeCarousel.module.scss";
import classNames from "classnames";

export const StickyGradeCarousel = (props: Props): ReactElement => {
  if (!props.gradeGroups || props.gradeGroups.length == 0) {
    return <></>;
  }

  return (
    <div className={styles.gradeTabsPosition}>
      <div className={styles.desktopGradeTabs}>
        {props.gradeGroups?.map((g, i) => (
          <div
            key={i}
            className={classNames(styles.gradeTab, {
              [styles.active]: g.id == props.grade,
            })}
            onClick={() => props.setGrade(g.id)}
          >
            {g.name}
          </div>
        ))}
      </div>
    </div>
  );
};

interface Props {
  gradeGroups: {
    id: number;
    name: string;
  }[];
  grade: number;
  setGrade: (_g: number) => void;
}
